export enum ServiceName {
  OFFERS = 'OFFERS',
  SURVEY = 'SURVEY',
  ORDER_TRACKER = 'ORDER_TRACKER',
}
